import customFetch, { checkForUnauthorizedResponse } from "../../utils/axios";
import { logoutUser } from "../user/userSlice";
import axiosInstance from "../../utils/axios";

export const getCategoriesAdminThunk = async (_, thunkAPI) => {
	try {
		const resp = await axiosInstance.get("/categories");

		return resp.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error.response.data.msg);
	}
};

export const getProductsAdminThunk = async (name, thunkAPI) => {
	try {
		const resp = await axiosInstance.get(`/products`);

		return resp.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error.response.data.msg);
	}
};
export const getSubCategoriesAdminThunk = async (name, thunkAPI) => {
	try {
		const resp = await axiosInstance.get(`/subcategories/`);

		return resp.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error.response.data.msg);
	}
};
export const clearStoreThunk = async (message, thunkAPI) => {
	try {
		thunkAPI.dispatch(logoutUser(message));
		return Promise.resolve();
	} catch (error) {
		return Promise.reject();
	}
};
